import script from "./privacyPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&setup=true&lang=js"

import "./privacyPolicy.vue?vue&type=style&index=0&id=20b780e3&scoped=true&lang=css"

import exportComponent from "D:\\java\\code\\overseas_code\\wlxf-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b780e3"]])

export default __exports__